<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="550"
    >        
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text">Action Required</v-card-title>
        <v-card-text class="pt-2 font-weight-regular" dark>
          Oops! Some information is missing or not recognized. Please review your application and make corrections before continuing.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>            
          <v-btn
            color="blue darken-1"
            text
            @click="emitCloseDialogEvent"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'ErrorsOnFormDialog',
    props: {
        showDialog: Boolean
    },
    methods:{
      emitCloseDialogEvent(){
        this.$emit("close-dialog");
      }
    }
  }
</script>